import React, { Component } from "react";
import { Route, Routes } from "react-router-dom";
// Pages
import MainContent from "./Pages/MainContent";
import LandingPage from "./Pages/LandingPage";
import CookiePolicy from "./Pages/CookiePolicy";
import PrivacyPolicy from "./Pages/PrivacyPolicy";

import "./Styles/main.scss";
import "./i18n";
import Header from "./Components/HeadComponent/Header";
import { basicFunctions } from "./Scripts/basicFunctions";
import { mainFunctions } from "./Scripts/mainFunctions";
import SignInPrompt from "./Components/Auth/SignInPrompt";
import CapturePopup from "./Components/Other/CapturePopup";
import Grid from "./Pages/Grid";
import Gallery from "./Pages/Gallery";
import Profile from "./Pages/Profile";
import SharePage from "./Pages/SharePage";
import FeedbackPopup from "./Components/Other/FeedbackPopup";
import { isAuthenticated } from "./Scripts/authHelper";

class Main extends Component<any, any> {
  basicFunctions: any;
  mainFunctions: any;
  tierListFunctions: any;
  createCommands: any;
  getCommands: any;
  postCommands: any;
  updateCommands: any;
  notificationHandler: any;
  t: any;
  initialQueryHasListTypeParam: boolean;
  initialListTypeFromQuery: string;
  constructor(props) {
    super(props);
    // Initialize state
    this.state = {
      user: null,
      isAuthenticated: isAuthenticated(),
      isGuest: false,
      showSignInPrompt: false,
      privacyMode: localStorage.getItem("privacyMode") === "true",
      language: localStorage.getItem("language") || "en",
      userProfileInfo: {}, // USER PROFILE INFO
      isMobile: undefined,
      tierListName: "",
      typePrefix: "Tier List",
      photoType: "Albums", // default
      initialTiers: {
        S: [],
        A: [],
        B: [],
        C: [],
        D: [],
        E: [],
        F: [],
      },
      artistList: [], // Used
      albumList: [], // Used
      songList: [], // Used
      notificationList: [],
      siteNotifications: [],
      popup: "",
      listType: "Albums",
      latestScreenshot: "",
      latestCaptureId: null,
      defaultYear: "2025",
      initialGroupByType: undefined,
      initialGroupByValue: undefined,
      customTiers: null,
      tierData: null,
      inspiredByCaptureId: null,
      albumPagination: null,
      artistPagination: null,
      songPagination: null,
      customItems: { Artists: [], Albums: [], Songs: [] }, // User's own custom-added items
    };

    const scripts = [
      { name: "mainFunctions", item: mainFunctions },
      { name: "basicFunctions", item: basicFunctions },
      ...basicFunctions.getFunctionFiles(),
    ];

    scripts.forEach((file) => {
      this[file.name] = Object.keys(file.item).reduce((acc, key) => {
        acc[key] = file.item[key].bind(this);
        return acc;
      }, {});
    });

    const initialSearch = props.location?.search || "";
    const initialPathname = props.location?.pathname || "";
    const pathParams = this.mainFunctions.parsePathParams(initialPathname);
    const queryParams = this.mainFunctions.parseQueryParams(initialSearch);
    // Path params take priority, but merge in query-only params (customTiers, from)
    const parsedParams = pathParams ? { ...queryParams, ...pathParams } : queryParams;
    const initialParams = new URLSearchParams(initialSearch);

    this.initialQueryHasListTypeParam = pathParams ? true : initialParams.has("listType");
    this.initialListTypeFromQuery = parsedParams.listType || "Albums";

    this.state = {
      ...this.state,
      ...parsedParams,
    };
    this.t = props.translations.t;
  }

  async componentDidMount() {
    if (this.state.artistList.length === 0) {
      this.mainFunctions.initPage();
    }
    this.updateUrlParams(this.state.listType, this.state.initialGroupByValue);
  }

  updateUrlParams = (listType = this.state.listType, groupValue?: string) => {
    const currentPathname = this.props.location?.pathname;
    if (currentPathname === "/Grid" || currentPathname === "/" || currentPathname?.startsWith("/profile") || currentPathname === "/Community" || currentPathname?.startsWith("/share")) {
      return;
    }

    const effectiveListType = (listType || "Albums").toLowerCase();
    let groupByValue: string | undefined;

    if (effectiveListType === "year") {
      groupByValue = groupValue || this.state.initialGroupByValue || this.state.defaultYear;
    } else if (effectiveListType === "artists") {
      groupByValue = groupValue || this.state.initialGroupByValue;
    } else if (effectiveListType === "songs") {
      const val = groupValue || this.state.initialGroupByValue;
      groupByValue = val && val !== "All" ? val : undefined;
    } else {
      // Albums
      const val = groupValue || this.state.initialGroupByValue || "All";
      groupByValue = val && val !== "All" ? val : undefined;
    }

    const newUrl = groupByValue
      ? `/tier-list/${effectiveListType}/${encodeURIComponent(groupByValue)}`
      : `/tier-list/${effectiveListType}`;

    // Don't navigate if we're already on this URL
    const currentUrl = `${this.props.location?.pathname || ""}${this.props.location?.search || ""}`;
    if (currentUrl === newUrl) return;

    if (this.props.navigate) {
      this.props.navigate(newUrl, { replace: true });
    } else {
      window.history.replaceState({}, "", newUrl);
    }
  };

  render() {
    return (
      <>
        <div
          id="main-wrapper"
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100vh",
          }}
        >
          {this.state.popup === "capturePopup" && <CapturePopup {...this} />}
          {this.state.popup === "feedbackPopup" && <FeedbackPopup {...this} />}

          <SignInPrompt {...this} />
          <div
            id="main-content"
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100vh",
            }}
          >
            <Header {...this} /> {/* Header */}
            <Routes>
              <Route path="/" element={<LandingPage {...this} />} />
              <Route path="/tier-list/*" element={<MainContent {...this} />} />
              <Route path="/TierList" element={<MainContent {...this} />} />
              <Route path="/Grid" element={<Grid {...this} />} />
              <Route path="/Community" element={<Gallery {...this} />} />
              <Route path="/profile/:userId" element={<Profile {...this} />} />
              <Route path="/share/:id" element={<SharePage />} />
              <Route path="/CookiePolicy" element={<CookiePolicy />} />
              <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
            </Routes>
          </div>
        </div>
      </>
    );
  }
}

export default Main;
